<kui-input-group [cleanAddons]="true"
    class="w-100 d-block">
    <kui-tag-input [invalid]="error || (field.required && (dirty && touched) && selectedItems().length === 0)"
        [placeholder]="field.placeholder || 'FORMS.TAGS.PLACEHOLDER' | translate"
        [autoCompleteItems]="autoCompleteItems"
        [freeText]="!autoCompleteItems"
        [selectedItems]="selectedItems()"
        (itemAdded)="addTag($event)"
        (itemRemoved)="removeTag($event)"
        [multiple]="true"></kui-tag-input>

    @if (field.actions) {
        <span kui-input-group-addon
            class="p-0"
            [class.border-danger]="error || (field.required && (dirty && touched) && selectedItems().length === 0)"
            [class.overlay]="overlay">

            @for (action of field.actions; track action.id || action.name) {
                @if (!action.dropdownValues && (action.name || action.icon)) {
                    <button kui-button
                        class="p-0"
                        color="none"
                        (click)="onActionClick(action)">
                        @if (action.icon) {
                            <kui-icon [name]="action.icon"
                                size="xs"
                                class="py-2 px-3"></kui-icon>
                        }
                        {{ action.name }}
                    </button>
                }
                @if (!!action.dropdownValues && (action.name || action.icon)) {
                    <kui-dropdown #dropdown
                        [style]="'none'"
                        [customContent]="dropdownContent"
                        [customContentContext]="{ component: dropdown }"
                        (onOpen)="overlay = true"
                        (onClose)="overlay = false">
                        @if(action.icon) {
                            <ng-container>
                                <kui-icon [name]="action.icon"
                                    size="xs"
                                    class="py-2 px-3"></kui-icon>
                                {{ action.name }}
                            </ng-container>
                        }
                    </kui-dropdown>
                    <ng-template #dropdownContent
                        let-component="component">
                        <div style="min-width: 200px">
                            <kui-tree-select [nodes]="action.dropdownValues"
                                #tree
                                (selectedNodeChanged)="onDropdownClick(component, tree, $event)"></kui-tree-select>
                        </div>
                    </ng-template>
                }
            }
        </span>
    }
</kui-input-group>

@if (field.required && (dirty && touched) && selectedItems().length === 0) {
    <div class="invalid-feedback d-block">
        <div>{{ 'FORMS.SHARED.REQUIRED' | translate:{ field: field.title } }}</div>
    </div>
}
@if (error) {
    <div class="invalid-feedback d-block">
        <div>{{ error }}</div>
    </div>
}